'use client';

import { useProfileActivitySummary } from './models';

import { PersonalDataCounts as PersonalDataCountsFeature } from '@/features/Landing';

export const PersonalDataCounts = () => {
  const { data: counts } = useProfileActivitySummary();

  return <PersonalDataCountsFeature {...counts} />;
};
